import type { AuthError } from "@azure/msal-browser";
import type { FC } from "react";

import { ErrorPage } from "src/errorHandling";
import { ErrorSource } from "src/types";

export const ErrorAuth: FC<{ error: AuthError | null }> = ({ error }) => (
    <ErrorPage source={ErrorSource.auth} error={error?.errorMessage} />
);
